import * as consts from './AgentConsts';
import { sendEmailReq } from '../helpers/requestUtils';
import { push } from 'react-router-redux';

import { savePosition } from '../app/AppActions';

export const contactAgent = (sender, agentType, token) => {
    return (dispatch, getState) => {

        const { tourId, tourType } = getState().app;

        dispatch({type: consts.SEND_EMAIL_PENDING});

        const to = `to${agentType.charAt(0).toUpperCase() + agentType.slice(1)}`;

        return sendEmailReq({
            sender_email: sender.email,
            sender_full_name: sender.name,
            sender_text_message: sender.comments,
            form_type: 'contact',
            mode: tourType,
            [to]: 1,
            token
        }, tourId).then(() => {
            dispatch({type: consts.SEND_EMAIL_FULFILLED});
        }, error => {
            dispatch({
                type: consts.SEND_EMAIL_REJECTED,
                payload: error
            });
        });
    }
}

export const navigateToContact = (element, agentType) => {
    return (dispatch, getState) => {
        dispatch(savePosition(element));
        dispatch(push(`/${getState().app.tourId}/${getState().app.tourType.charAt(0)}/contact${agentType}`));
    }
}